import { BaseQueryBuilder } from "./base-query-builder";
import { LookupClientService } from "../../../../../../../../services/lookups/lookup-client.service";
import { CustomerService } from "../../../../../../../../services/modules/customer-client.service";
import { ManageRightShipUsersClientService } from "../../../../../../../../services/modules/righship-qi-manage-users.service";
import { autoinject, transient } from "aurelia-framework";
import { DataType } from "../../../../../../../../models/queries/queries.models";
import { DateExpressionParser } from "../../../../../../../../configuration/date-expressions";
import * as moment from "moment";
import { EditableFieldBinding, GridUtils } from "../../../../../../../components/data-grid/data-grid";
import { BindingSignaler } from "aurelia-templating-resources";
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";

class RuleParameterQueryFilter {
    isRuleParameter: boolean;
    ruleConfigParameterId: number;
    filterRuleConfigParameterId: number;
    value: string;
}

@autoinject
@transient()
export class VettingruleparametersQueryBuilder extends BaseQueryBuilder<RuleParameterQueryFilter> {
    
    constructor(lookupService: LookupClientService, customerService: CustomerService,
        manageRightShipUsersClientService: ManageRightShipUsersClientService, private bindingSignaler:BindingSignaler, protected configService: ConfigService) {
        super(lookupService, customerService, manageRightShipUsersClientService, configService);
        
    }

    itemSource: { name: string; id: number; mapping: string; }[] = [
        {name: "days", id: 1, mapping: "today"},
        {name: "weeks", id: 1, mapping: "week"},
        {name: "months", id: 2, mapping: "month"},
        {name: "years", id: 3, mapping: "year"}
    ];
    
    public async filtersHtml(filter: RuleParameterQueryFilter, dataType: number, lookupMappedToProperty:string) {
        if (dataType == DataType.Date || dataType == DataType.DateTime) {
            if (!DateExpressionParser.isDateExpression(filter.value)) {
                const x = new Date();
                filter.value = moment(filter.value).add((x.getTimezoneOffset() / 60) * -1, "h").toISOString();
            }
        }

        const displayValue = await this.getDisplayValue({
            filterValue: filter.value,
            filterProperty: {
                lookupMappedToProperty: lookupMappedToProperty,
                type: dataType,
                isNullable: false,
                isDynamicProperty: false
            },
            skipOnNullOrEmpty: false,
            filterOperator: {
                translatedSymbol: "="
            }
        }, null);
        const binding: EditableFieldBinding = {
            query: `"${lookupMappedToProperty}"`,
            lookup: lookupMappedToProperty,
            isEditable: !this.readonly,
            binding: "item.value",
            value: `"${lookupMappedToProperty}"`,
            displayValueBinding: `'${displayValue}'`,
            dataType: dataType,
            parameter: "item.value",
            secondParameter: null,
            parameterObj: null,
            isNullable: true,
            isNotRangeDatePicker: true,
            isDisabled: this.disabled,
            isValueCollection: false,
            isPropertyCollection: false
        };

     
        if(dataType == DataType.DateRange){
            return `
            <div class="row nowrap">
                <text-box class="col col-sm-4" value.two-way="item.value | dateRange :{type: 'date', item:item}" type="integer"
                    placeholder.bind="dvm.selectedItem.name" disabled.bind="disabled"></text-box>
        
                <combo-box class="col col-sm-4" view-model.ref="dvm" selected-value.two-way="item.value | dateRange :{type: 'day', item:item}" selected-value-path="mapping"
                    display-member-path="name" set-default.bind="true" item-source.bind="itemSource" disabled.bind="disabled"></combo-box>
            </div>
            `
        }

        if (dataType == DataType.Boolean && this.readonly)
            return `<div>${displayValue}</div>`;

        return GridUtils.getControl(binding, false);
    }

    triggerChange(){
        this.bindingSignaler.signal("filterPropertyChanged");
    }
}